(function () {
  // Guard against double-inclusion (this asset is referenced both globally in
  // layout/theme.liquid and inside the cart section). Wrapping the whole file
  // in an IIFE keeps its declarations function-scoped, so a second <script>
  // include can't redeclare top-level `const observer` (which threw a
  // SyntaxError and aborted the second load); the flag then no-ops the second
  // execution so listeners/observers/intervals are only ever set up once.
  if (window.__bundleCartMergeLoaded) return;
  window.__bundleCartMergeLoaded = true;

var mergeTimeout;
var isMerging = false;
var mergeStartedAt = 0;
var bundleSyncing = false;
// A merge normally releases its own lock when it finishes; this only frees a
// lock left behind by a request that never settled.
var MERGE_LOCK_TIMEOUT = 10000;

function mergeLocked() {
  return isMerging && Date.now() - mergeStartedAt < MERGE_LOCK_TIMEOUT;
}

document.documentElement.classList.add('bundle-count-loading');
setTimeout(function() { document.documentElement.classList.remove('bundle-count-loading'); }, 1500);

function findCartSectionId() {
  var table = document.querySelector('.cart-items__table');
  if (!table) return null;
  var section = table.closest('[id^="shopify-section-"]');
  return section ? section.id.replace('shopify-section-', '') : null;
}

function refreshCartSection() {
  var sectionId = findCartSectionId();
  if (!sectionId) { window.location.reload(); return Promise.resolve(); }
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sections: [sectionId] })
  })
    .then(res => res.json())
    .then(data => {
      var html = data.sections && data.sections[sectionId];
      if (!html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.getElementById('shopify-section-' + sectionId);
      var current = document.getElementById('shopify-section-' + sectionId);
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    });
}

function reconcileFlavourLines(cart) {
  if (bundleSyncing) return true;

  var parents = cart.items.filter(function(item) {
    return item.properties && item.properties['Bundle Size'];
  });
  var flavours = cart.items.filter(function(item) {
    return item.properties && item.properties['_bundle'] === 'true';
  });
  if (flavours.length === 0) return false;

  var lineByName = {};
  flavours.forEach(function(line) {
    var name = String(line.variant_title || line.product_title || '').split(' | ')[0].trim();
    if (name) lineByName[name] = line;
  });

  var desired = {};
  flavours.forEach(function(line) { desired[line.key] = 0; });

  parents.forEach(function(parent) {
    var parentQty = parent.quantity;
    Object.keys(parent.properties).forEach(function(key) {
      if (key.charAt(0) === '_' || key === 'Bundle Size') return;
      var match = String(parent.properties[key]).match(/^(\d+)\s*x/i);
      if (!match) return;
      var line = lineByName[key.trim()];
      if (line) desired[line.key] += parseInt(match[1], 10) * parentQty;
    });
  });

  var updates = {};
  var changed = false;
  flavours.forEach(function(line) {
    if (desired[line.key] !== line.quantity) {
      updates[line.key] = desired[line.key];
      changed = true;
    }
  });
  if (!changed) return false;

  bundleSyncing = true;
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: updates })
  })
    .then(function() { return refreshCartSection(); })
    .then(function() { bundleSyncing = false; isMerging = false; debouncedMerge(); })
    .catch(function() { bundleSyncing = false; isMerging = false; });
  return true;
}

function mergeBundleLines() {
  if (bundleSyncing) return;
  if (mergeLocked()) return;
  isMerging = true;
  mergeStartedAt = Date.now();
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (reconcileFlavourLines(cart)) return;

      // Pause the scoped observer while we mutate bundle rows, then re-attach to
      // the current container (a section refresh may have replaced it).
      cartObserver.disconnect();
      try {
      const rows = document.querySelectorAll('.cart-items__table-row');
      const bundleRows = Array.from(rows).filter(row => {
        const bundleKey = row.dataset.key;
        const cartItem = cart.items.find(item => item.key === bundleKey);
        return cartItem && cartItem.properties && cartItem.properties['Bundle Size'];
      });

      if (bundleRows.length === 0) { updateCartCount(cart); return; }

      bundleRows.forEach(function(bundleRow) {
        bundleRow.querySelectorAll('.cart-items__properties, .cart-items__unit-price-wrapper, .cart-items__variants-wrapper').forEach(el => el.style.display = 'none');
        bundleRow.querySelectorAll('.bundle--injected').forEach(el => el.remove());

        bundleRow.classList.add('bundle-row');

        const qtyWrapper = bundleRow.querySelector('.quantity-selector');
        if (qtyWrapper) qtyWrapper.style.width = 'fit-content';
        if (qtyWrapper) qtyWrapper.style.minWidth = 'unset';

        bundleRow.querySelectorAll('.quantity-selector button').forEach(function(btn) {
          btn.disabled = false;
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
        });
        const qtyInput = bundleRow.querySelector('.quantity-selector input');
        if (qtyInput) {
          qtyInput.disabled = false;
          qtyInput.removeAttribute('disabled');
          qtyInput.removeAttribute('readonly');
        }

        const deleteBtn = bundleRow.querySelector('.cart-items__remove');
        if (deleteBtn && qtyWrapper && qtyWrapper.contains(deleteBtn)) {
          qtyWrapper.parentNode.insertBefore(deleteBtn, qtyWrapper.nextSibling);
        }

        const bundleKey = bundleRow.dataset.key;
        const bundleItem = cart.items.find(item => item.key === bundleKey);
        if (!bundleItem) return;

        const props = bundleItem.properties || {};
        const upchargeCents = parseInt(props['_upcharge'] || '0');
        const basePriceCents = bundleItem.price;
        const currentQty = bundleItem.quantity;
        const totalPriceCents = (basePriceCents + upchargeCents) * currentQty;
        const bottleSize = props['Bundle Size'] || '';
        const sizeLabel = bottleSize.includes('Small') ? 'Small' : 'Medium';
        const productInfo = bundleRow.querySelector('.cart-items__product-info');

        const titleEl = bundleRow.querySelector('.cart-items__title');
        if (titleEl) titleEl.textContent = 'party pack';

        productInfo.insertAdjacentHTML('beforeend',
          `<p class="bundle--injected" style="font-size:var(--font-size--sm); color:rgb(var(--color-foreground-rgb)/var(--opacity-70)); margin-top:2px;">${sizeLabel}</p>`
        );

        let flavourHTML = '<ul class="bundle--injected list-unstyled" style="margin-top:8px; padding:0; list-style:none;">';
        Object.keys(props).forEach(key => {
          if (key.startsWith('_') || key === 'Bundle Size') return;
          const val = props[key];
          const upchargeMatch = val.match(/\+\$[\d.]+/);
          const upchargeStr = upchargeMatch ? upchargeMatch[0] : '';
          const qtyMatch = val.match(/^(\d+)x/);
          const perBundleQty = qtyMatch ? parseInt(qtyMatch[1], 10) : 0;
          const displayQty = perBundleQty * currentQty;
          flavourHTML += `<li class="bundle--injected" style="display:flex; justify-content:space-between; font-size:var(--font-size--sm); color:rgb(var(--color-foreground-rgb)/var(--opacity-70)); margin-bottom:4px;">
            <span>${displayQty}x ${key}</span>
            <span style="margin-left:8px; white-space:nowrap;">${upchargeStr}</span>
          </li>`;
        });
        flavourHTML += '</ul>';
        productInfo.insertAdjacentHTML('beforeend', flavourHTML);

        const bundlePriceEl = bundleRow.querySelector('.cart-items__price text-component');
        if (bundlePriceEl) {
          bundlePriceEl.textContent = `$${(totalPriceCents / 100).toFixed(2)} SGD`;
        }

        if (deleteBtn && !deleteBtn._bundleListenerAdded) {
          deleteBtn._bundleListenerAdded = true;
          deleteBtn.addEventListener('click', function() {
            setTimeout(function() {
              debouncedMerge();
            }, 500);
          });
        }
      });
      updateCartCount(cart);
      } finally {
        observeCartItems();
      }
    })
    .catch(() => {})
    .finally(() => { if (!bundleSyncing) isMerging = false; });
}

function updateCartCount(cart) {
  if (!cart) {
    fetch('/cart.js').then(res => res.json()).then(updateCartCount);
    return;
  }

  const bundleCount = cart.items
    .filter(item => item.properties && item.properties['Bundle Size'])
    .reduce((sum, item) => sum + item.quantity, 0);

  const otherCount = cart.items
    .filter(item => !(item.properties && item.properties['_bundle'] === 'true') && !(item.properties && item.properties['Bundle Size']) && !(item.properties && item.properties['_delivery_fee'] === 'true'))
    .reduce((sum, item) => sum + item.quantity, 0);

  const totalDisplay = bundleCount + otherCount;
  // Write the count only to the innermost count element (ref="cartBubbleCount"
  // / .cart-bubble__text-count). Targeting the wrapper .cart-bubble__text with
  // textContent used to REPLACE its children, deleting the nested
  // cartBubbleCount span — which then made cart-icon.js throw
  // "Required ref cartBubbleCount not found" on every mutation. Writing to the
  // inner element preserves the DOM structure the native component expects.
  document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(el => {
    el.textContent = totalDisplay;
  });
  document.documentElement.classList.remove('bundle-count-loading');
}

function debouncedMerge() {
  clearTimeout(mergeTimeout);
  mergeTimeout = setTimeout(mergeBundleLines, 50);
}

// Scoped, event-driven detection of cart-item changes (native quantity edits,
// removals, section re-renders) — replaces the old 100ms innerHTML-diff poll.
// Observes ONLY the cart-page items container, not the delivery widget (which
// lives in a sibling column and mutates constantly). Loop-safe: mergeBundleLines
// disconnects this observer around its own bundle-row writes and re-attaches
// after, so injected nodes can never re-trigger a merge.
var cartObserver = new MutationObserver(function() {
  if (mergeLocked() || bundleSyncing) return;
  debouncedMerge();
});
function observeCartItems() {
  cartObserver.disconnect();
  var host = document.querySelector('.cart-page__items');
  if (host) cartObserver.observe(host, { childList: true, subtree: true, characterData: true, attributes: true });
}

document.addEventListener('DOMContentLoaded', mergeBundleLines);

document.addEventListener('DOMContentLoaded', function() {
  updateCartCount(null);
});

document.addEventListener('cart:updated', function() {
  setTimeout(debouncedMerge, 500);
});

document.addEventListener('cart:refresh', function() {
  setTimeout(debouncedMerge, 500);
});

document.addEventListener('shopify:section:load', debouncedMerge);
document.addEventListener('DOMContentLoaded', observeCartItems);
document.addEventListener('shopify:section:load', observeCartItems);

// Watches the whole page for cart rows being rendered (cart page morphs, the
// drawer hydrating), so skip anything outside the cart areas before scanning
// added nodes — this observer sees every DOM change on every page.
const CART_AREAS = 'cart-drawer-component, .cart-drawer, .cart-page__items, .cart-items';
const observer = new MutationObserver(function(mutations) {
  if (mergeLocked()) return;
  const relevant = mutations.some(m =>
    m.addedNodes.length && m.target.nodeType === 1 && (m.target.matches(CART_AREAS) || m.target.closest(CART_AREAS) || m.target.querySelector(CART_AREAS)) &&
    Array.from(m.addedNodes).some(n =>
      n.nodeType === 1 && (
        n.classList?.contains('cart-items__table-row') ||
        n.querySelector?.('.cart-items__table-row')
      )
    )
  );
  if (relevant) debouncedMerge();
});

document.addEventListener('DOMContentLoaded', function() {
  observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('dialog:open', function() {
  setTimeout(mergeBundleLines, 300);
});

document.addEventListener('cart-drawer:open', function() {
  setTimeout(mergeBundleLines, 300);
});

const drawerObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.target.classList?.contains('cart-drawer__dialog') ||
        mutation.target.closest?.('.cart-drawer__dialog')) {
      debouncedMerge();
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const dialog = document.querySelector('.cart-drawer__dialog, [data-testid="cart-drawer-dialog"]');
  if (dialog) {
    drawerObserver.observe(dialog, { childList: true, subtree: true, attributes: true });
  }
});

(function() {
  const style = document.createElement('style');
  style.textContent = `
    html.bundle-count-loading .cart-bubble__text-count,
    html.bundle-count-loading .cart-bubble__text { visibility: hidden !important; }
    .cart-items__table-row.flavour-row { display: none; }
    .bundle-row .cart-items__remove {
      display: flex !important;
      align-items: center !important;
      align-self: center !important;
      margin-top: 0 !important;
      top: auto !important;
      position: relative !important;
      margin-left: 12px !important;
    }
    .bundle-row .quantity-selector {
      width: fit-content !important;
      min-width: unset !important;
    }
    .cart-drawer .bundle--injected p {
      font-size: 13px !important;
      color: black !important;
      opacity: 1 !important;
      font-weight: 500;
    }
    .cart-drawer .bundle--injected ul {
      font-size: 11px !important;
      opacity: 0.6 !important;
    }
    .cart-drawer .bundle--injected li {
      font-size: 11px !important;
      margin-bottom: 1px !important;
    }
  `;
  document.head.appendChild(style);
})();

})();
